import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { defaultLoadingClass } from './Constants';
import './LazyImage.scss';
var LazyImage = function (props) {
    var src = props.src, altText = props.altText, classes = props.classes, loadingClasses = props.loadingClasses, rootMargin = props.rootMargin, containerRef = props.containerRef, height = props.height, width = props.width, fallbackURL = props.fallbackURL;
    var _a = useInView({
        root: (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || null,
        triggerOnce: true,
        rootMargin: rootMargin || '200px 200px 200px 200px',
    }), ref = _a[0], inView = _a[1];
    var imageOnErrorHandler = function (event) {
        if (typeof fallbackURL === 'string') {
            // eslint-disable-next-line no-param-reassign
            event.currentTarget.src = fallbackURL;
        }
    };
    return (React.createElement("span", { className: "sui-inline-block", ref: ref }, inView ? (React.createElement("img", { className: classes, src: src, alt: altText, height: height, width: width, onError: imageOnErrorHandler })) : (React.createElement("div", { className: loadingClasses || defaultLoadingClass }))));
};
export { LazyImage };
